import script from "./Pc.vue?vue&type=script&lang=js"
export * from "./Pc.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__